import { createFileRoute } from "@tanstack/react-router";
import MyAlerts from "@/pages/MyAlerts";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/my-alerts/")({
  head: () => routeHead("/my-alerts/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><MyAlerts /></PrivateRoute>
  );
}
